import { Component } from '@theme/component';

/**
 * A thin fixed bar that fills left-to-right as the visitor scrolls down the
 * page, used on long-form article pages.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} bar
 *
 * @extends Component<Refs>
 */
export default class StoryProgress extends Component {
  /** @type {number | null} */
  #rafId = null;

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('scroll', this.#onScroll);
    if (this.#rafId !== null) window.cancelAnimationFrame(this.#rafId);
  }

  #onScroll = () => {
    if (this.#rafId !== null) return;
    this.#rafId = window.requestAnimationFrame(() => {
      this.#rafId = null;
      this.#update();
    });
  };

  #update() {
    const { bar } = this.refs;
    if (!bar) return;

    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    const progress = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;

    bar.style.width = `${Math.min(100, Math.max(0, progress))}%`;
  }
}

if (!customElements.get('story-progress')) {
  customElements.define('story-progress', StoryProgress);
}
